

<app-header></app-header>
<div class="content_section w-100 float-left">
   <div class="container">
       <div class="row">
          <div class="wrapper_content w-100 float-left">
                <div class="row m-0">
                    <div class="col-lg-5 col-md-12 col-sm-12">
                        <ngx-gallery [options]="galleryOptions_1" [images]="galleryImages_1" class="ngx-gallery_1"></ngx-gallery>
                    </div>
                    <div class="col-lg-7 col-md-12 col-sm-12">
                        <div class="para_contents">
                            <h1 class="mb-3 text-white upper_case"> <span class="text-dy">254-8943:</span> 914 mm (36 in) Pin On</h1>
                            <div class="select_flex">
                                <div class="form-group mb-0 flex_first">
                                    <label for="" class="text-white mb-0">Select QUANTITY</label>
                                    <select class="form-control ml-2" name="" id="">
                                        <option value="">2</option>
                                        <option value="">1</option>
                                    </select>
                                </div>
                            </div>

                            <div class="content_flex">
                                <h6 class="header_description mt-4">GMMCO1001</h6>
                                <p class="text-white ">High Strength steel coil last in your excavator loner and bears loads up to 6 ton</p>
                                <h6 class="header_description upper_case mt-2">Compatiblity</h6>
                                <ul>
                                    <li class="mb-1"> <img src="../../../assets/images/tick.png" alt=""> Excavator 4 Ton Mini 200 BHP</li>
                                    <li><img src="../../../assets/images/tick.png" alt=""> Excavator 4 Ton Mini 200 BHP</li>
                                </ul>
                                <h6 class="header_description upper_case mt-4">Specifications</h6>
                                <h6 class="header_description"> Morot Displacement: <span class="text-white">2.67 In3</span> </h6>
                                <h6 class="header_description"> Mounting Bracket Design:<span class="text-white">Backhoe Loader Pin Lock</span> </h6>
                                <h6 class="header_description"> Optimal Hydraulic Flow: <span class="text-white">95-130 L/min (25-34 RPM</span> </h6>
                                <h6 class="header_description"> Optimal Hydraulic Pressure: <span class="text-white">207-290bar (3002-4206)</span> </h6>

                                <button routerLink="/customer/category-part-detail2" class="btn-get_price mt-3">Get Price and ETA</button>
                            </div>
                        </div>
                    </div>
                </div>
          </div>
       </div>
   </div>
</div>
<app-footer></app-footer>

 